module.exports = __webpack_public_path__ + "static/media/enfermagem.33d3405e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/box_courses/enfermagem.jpg
// module id = 24
// module chunks = 0